import { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { account } from '../../appwrite/config';

function Sidebar() {
    const { role } = useAuth();

    const location = useLocation();
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(null);

    useEffect(() => {
        document.documentElement.className = "";

        checkSession();
    }, []);

    const checkSession = async () => {
        try {
            const userData = await account.get();
            //setUser(userData);
            setIsLoggedIn(true);
        } catch {
            setIsLoggedIn(false);
            //navigate('/');
        }

        //JWT Token
        const token = sessionStorage.getItem('JWT_TOKEN');
        if (token === null) {
            setIsLoggedIn(false);
            logout();
        }
    };

    const logout = async () => {
        await account.deleteSession("current");
        //localStorage.removeItem("isLoggedIn");
        navigate("/");

        window.location.reload();
    };

    const isActiveClass = (paths) => {
        if (Array.isArray(paths)) {
            return paths.some(path => location.pathname.startsWith(path));
        }

        return location.pathname.startsWith(paths);
    };

    return (
        <aside className="aside is-placed-left is-expanded">
            <div className="aside-tools">
                <div>
                    <Link to={isLoggedIn ? "/dashboard" : "/"}>
                        Admin <b className="font-black">Panel</b>
                    </Link>
                </div>
            </div>
            <div className="menu is-menu-main">
                <ul className="menu-list">
                    <li className={isActiveClass('/dashboard') ? 'active' : ''}>
                        <Link to={isLoggedIn ? "/dashboard" : "/"}>
                            <span className="icon"><i className="mdi mdi-desktop-mac"></i></span>
                            <span className="menu-item-label">Dashboard</span>
                        </Link>
                    </li>
                    {["admin", "business"].includes(role) && (
                        <li className={isActiveClass(['/shops', '/shop']) ? 'active' : ''}>
                            <Link to={isLoggedIn ? "/shops" : "/"}>
                                <span className="icon"><i className="mdi mdi-cart"></i></span>
                                <span className="menu-item-label">Businesses</span>
                            </Link>
                        </li>
                    )}
                    {role === "admin" && (
                        <li className={isActiveClass(['/categories', '/category']) ? 'active' : ''}>
                            <Link to={isLoggedIn ? "/categories" : "/"}>
                                <span className="icon"><i className="mdi mdi-apps"></i></span>
                                <span className="menu-item-label">Categories</span>
                            </Link>
                        </li>
                    )}
                    {["admin", "business"].includes(role) && (
                        <li className={isActiveClass(['/coupons', '/coupon']) ? 'active' : ''}>
                            <Link to={isLoggedIn ? "/coupons" : "/"}>
                                <span className="icon"><i className="mdi mdi-cash-100"></i></span>
                                <span className="menu-item-label">Coupons</span>
                            </Link>
                        </li>
                    )}
                    {["admin", "event"].includes(role) && (
                        <li className={isActiveClass(['/events', '/event']) ? 'active' : ''}>
                            <Link to={isLoggedIn ? "/events" : "/"}>
                                <span className="icon"><i className="mdi mdi-calendar-clock"></i></span>
                                <span className="menu-item-label">Events</span>
                            </Link>
                        </li>
                    )}
                    
                    {["admin", "course"].includes(role) && (
                        <li className={isActiveClass(['/courses', '/course']) ? 'active' : ''}>
                            <Link to={isLoggedIn ? "/courses" : "/"}>
                                <span className="icon"><i className="mdi mdi-book-open"></i></span>
                                <span className="menu-item-label">Holidays</span>
                            </Link>
                        </li>
                    )}
                    {role === "admin" && (
                        <li className={isActiveClass(['/users', '/user']) ? 'active' : ''}>
                            <Link to={isLoggedIn ? "/users" : "/"}>
                                <span className="icon"><i className="mdi mdi-account-multiple"></i></span>
                                <span className="menu-item-label">Users</span>
                            </Link>
                        </li>
                    )}
                    {role === "admin" && (
                        <li className={isActiveClass(['/bookings', '/booking']) ? 'active' : ''}>
                            <Link to={isLoggedIn ? "/bookings" : "/"}>
                                <span className="icon"><i className="mdi mdi-bookmark"></i></span>
                                <span className="menu-item-label">Booking Management</span>
                            </Link>
                        </li>
                    )}




                    {/* <li className={isActiveClass('/dashboard') ? 'active' : ''}>
                        <a href={isLoggedIn ? "/dashboard" : <Login />}>
                            <span className="icon"><i className="mdi mdi-desktop-mac"></i></span>
                            <span className="menu-item-label">Dashboard Atag</span>
                        </a>
                    </li>
                    <li className={isActiveClass('/categories') ? 'active' : ''}>
                        <a href={isLoggedIn ? "/categories" : <Login />}>
                            <span className="icon"><i className="mdi mdi-apps"></i></span>
                            <span className="menu-item-label">Categories</span>
                        </a>
                    </li>
                    <li className={isActiveClass('/shops') ? 'active' : ''}>
                        <a href={isLoggedIn ? "/shops" : <Login />}>
                            <span className="icon"><i className="mdi mdi-cart"></i></span>
                            <span className="menu-item-label">Businesses</span>
                        </a>
                    </li>
                    <li className={isActiveClass('/coupons') ? 'active' : ''}>
                        <a href={isLoggedIn ? "/coupons" : <Login />}>
                            <span className="icon"><i className="mdi mdi-cash-100"></i></span>
                            <span className="menu-item-label">Coupons</span>
                        </a>
                    </li>
                    <li className={isActiveClass('/events') ? 'active' : ''}>
                        <a href={isLoggedIn ? "/events" : <Login />}>
                            <span className="icon"><i className="mdi mdi-calendar-check"></i></span>
                            <span className="menu-item-label">Events</span>
                        </a>
                    </li>
                    <li className={isActiveClass('/courses') ? 'active' : ''}>
                        <a href={isLoggedIn ? "/courses" : <Login />}>
                            <span className="icon"><i className="mdi mdi-calendar-check"></i></span>
                            <span className="menu-item-label">Courses</span>
                        </a>
                    </li>
                    <li className={isActiveClass('/customers') ? 'active' : ''}>
                        <a href={isLoggedIn ? "/customers" : <Login />}>
                            <span className="icon"><i className="mdi mdi-calendar-check"></i></span>
                            <span className="menu-item-label">Customers</span>
                        </a>
                    </li>
                    <li className={isActiveClass('/bookings') ? 'active' : ''}>
                        <a href={isLoggedIn ? "/bookings" : <Login />}>
                            <span className="icon"><i className="mdi mdi-calendar-check"></i></span>
                            <span className="menu-item-label">Booking Management</span>
                        </a>
                    </li> */}
                </ul>
            </div>
        </aside>
    );
}


export default Sidebar;


